import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { ISmartArtModel } from '@src/slide/domain/ui-model/element-modeles/Interface/smart-art-model.interface';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';
import { BaseCopySdkModel, ElementBaseCopySdkModel, IBaseCopySdkModel } from './model/base';
import { SectionCopySdkModel } from './model/section';
import { ShapeCopySdkModel } from './model/shape';
import { GroupCopySdkModel } from './model/group';
import { SmartArtCopySdkModel } from './model/smartArt';


/**
 * 复制时候使用的sdk model
 * @param model
 */
export function getElementCopiedSdkModelByModel(model: IBaseModel): IBaseCopySdkModel {
    switch (model.type) {
        case UIModelType.SHAPE:
            return new ShapeCopySdkModel(model as IShapeModel);
        case UIModelType.GROUP:
            return new GroupCopySdkModel(model as IGroupModel);
        case UIModelType.SMART_ART:
            return new SmartArtCopySdkModel(model as ISmartArtModel);
        case UIModelType.SECTION:
            return new SectionCopySdkModel(model as ISectionModel);
        case UIModelType.IMAGE:
        case UIModelType.TABLE:
        case UIModelType.CHART:
            return new ElementBaseCopySdkModel(model as IElementBaseModel);
        default:
            return new BaseCopySdkModel(model);
    }
}
